import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Megaphone, Cpu, ArrowRight } from 'lucide-react';
import ScrollReveal from '@/components/ScrollReveal';

const DivisionSplit = () => {
  const divisions = [
    {
      to: '/marketing-agency',
      icon: Megaphone,
      eyebrow: 'Marketing Agency',
      title: 'Farti notare, scegliere e vendere',
      description:
        'Portiamo le persone giuste davanti alla tua azienda e le trasformiamo in clienti. SEO, Ads, social, siti che convertono.',
      cta: 'Scopri la divisione Marketing',
    },
    {
      to: '/digital-solutions',
      icon: Cpu,
      eyebrow: 'Digital Solutions',
      title: 'Farla girare meglio e più in fretta',
      description:
        'Sistemi, automazioni AI e software su misura per ridurre errori, tempo perso e collegare quello che oggi non parla.',
      cta: 'Scopri la divisione Digital',
    },
  ];

  return (
    <section className="py-20 md:py-28 relative" aria-labelledby="divisioni-heading">
      <div className="container-premium">
        <ScrollReveal>
          <div className="text-center max-w-3xl mx-auto mb-14 md:mb-20">
            <p className="text-gold tracking-[0.2em] uppercase text-sm mb-4">Due anime. Un solo partner</p>
            <h2 id="divisioni-heading" className="font-serif text-3xl md:text-5xl mb-6">
              Da una parte facciamo crescere i tuoi <span className="text-gradient-gold">numeri</span>.
              <br className="hidden md:block" />
              Dall'altra rendiamo la tua azienda una <span className="text-gradient-gold">macchina che gira</span>.
            </h2>
            <p className="text-muted-foreground text-lg">Insieme.</p>
          </div>
        </ScrollReveal>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8">
          {divisions.map((d, i) => (
            <motion.div
              key={d.to}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-80px' }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
            >
              <Link
                to={d.to}
                className="group block glass-card-hover p-8 md:p-10 h-full relative overflow-hidden"
              >
                <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none"
                  style={{ background: 'radial-gradient(circle at 30% 20%, hsl(42 50% 59% / 0.10), transparent 60%)' }}
                />
                <div className="relative">
                  <div className="w-14 h-14 rounded-xl bg-gold/15 border border-gold/30 flex items-center justify-center mb-6 group-hover:bg-gold/25 transition-colors">
                    <d.icon className="w-7 h-7 text-gold" aria-hidden="true" />
                  </div>
                  <p className="text-xs uppercase tracking-widest text-gold/80 mb-3">{d.eyebrow}</p>
                  <h3 className="font-serif text-2xl md:text-3xl mb-4 group-hover:text-gold transition-colors">
                    {d.title}
                  </h3>
                  <p className="text-muted-foreground mb-8">{d.description}</p>
                  <div className="inline-flex items-center gap-2 text-gold font-medium group-hover:gap-4 transition-all">
                    <span>{d.cta}</span>
                    <ArrowRight className="w-5 h-5" />
                  </div>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DivisionSplit;
